/* eslint-disable unicorn/no-array-reduce */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import type { BottegaBlock } from '@velasca/types'
import { $bottega_blocks, $city_icons } from '@velasca/utils/globals'
import { useBottega } from '../../BottegaProvider'

interface IconListProps {
  id: string
}

type CityIcons = [
  'milano',
  'roma',
  'torino',
  'bologna',
  'firenze',
  'parigi',
  'londra',
  'palermo',
  'forte-dei-marmi',
  'monaco',
  'copenhagen',
  'new-york',
  'brescia',
  'padova',
  'verona',
]

const IconList = ({ id }: IconListProps) => {
  const bottega = useBottega()

  if (!bottega) {
    return null
  }

  const { currentCityGroup, setCity } = bottega

  const Icons = $bottega_blocks.reduce(
    (a: string[], { city_group }: BottegaBlock) =>
      city_group && !a.includes(city_group) ? [...a, city_group] : a,
    [],
  ) as CityIcons

  const setAndScroll = (icon: string) => {
    setCity(icon)
  }

  interface TagAttributes {
    className: string
    id?: string
  }

  const tagAttributes: TagAttributes = {
    className: 'icon-list col-xs-12',
  }

  if (id) {
    tagAttributes.id = id
  }

  return (
    <div {...tagAttributes}>
      {Icons.map((icon, i) => (
        <div
          className={`icon ${icon === currentCityGroup ? 'active' : ''}`}
          style={{ width: '12rem' }}
          key={i}
          onClick={() => {
            setAndScroll(icon)
          }}
        >
          <div className="image">
            <img
              src={$city_icons[icon as keyof typeof $city_icons]}
              alt={`${icon} | Velasca`}
            />
          </div>
          <p>{icon.replaceAll('-', ' ')}</p>
        </div>
      ))}
    </div>
  )
}

export default IconList
